// extracted by mini-css-extract-plugin
export default {"content":"ChallengeResumeWidget_content__bioXF","btn":"ChallengeResumeWidget_btn__s7aLx"};